// extracted by mini-css-extract-plugin
export var block = "button-module--block--98949";
export var btn = "button-module--btn--07c14";
export var disabled = "button-module--disabled--b012a";
export var focused = "button-module--focused--8c418";
export var ghost = "button-module--ghost--525e9";
export var large = "button-module--large--5cf14";
export var overlay = "button-module--overlay--5e964";
export var pressed = "button-module--pressed--42d6a";
export var small = "button-module--small--7f783";